module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/adjust-3dd8f99dc2f00c356ea433b38974e499.svg";